import { useEffect, useMemo, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../app/components/ui/select";
import { api } from "../../lib/api";
import { useAuth } from "../../providers/AuthProvider";

export type ProductOption = { id: string; name: string; sku: string | null };

export function ProductSelector({
  value,
  onValueChange,
  disabled,
  placeholder = "Select product",
}: {
  value: string;
  onValueChange: (next: string) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  const { token } = useAuth();
  const [rows, setRows] = useState<ProductOption[]>([]);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    (async () => {
      const res = await api.products.list({ token });
      if (!cancelled) {
        setRows(res.data.map((p) => ({ id: p.id, name: p.name, sku: p.sku })));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const sorted = useMemo(() => [...rows].sort((a, b) => a.name.localeCompare(b.name)), [rows]);

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {sorted.map((p) => (
          <SelectItem key={p.id} value={String(p.id)}>
            {p.name}{p.sku ? ` (${p.sku})` : ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

